// extracted by mini-css-extract-plugin
export default {"wrapperBox":"AddCover_wrapperBox__SErJ0","wrapper":"AddCover_wrapper__wpWnb","icon":"AddCover_icon__KuRhd","text":"AddCover_text__t8e5X"};